import { VectorResult } from './vector-result';

/**
 * Result class for Condition processes
 * Inherits from VectorResult (which includes ProcessResult properties)
 * Currently no additional properties are exposed
 */
export class ConditionResult extends VectorResult {
  constructor(data: any) {
    super(data);
  }
}
